import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { fromEvent, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'md-input-autocomplete',
  templateUrl: './md-input-autocomplete.component.html',
  styleUrls: ['./md-input-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MdInputAutocompleteComponent),
      multi: true,
    },
  ],
})
export class MdInputAutocompleteComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  @Input() color:
    | 'primary'
    | 'primary-stroked'
    | 'primary-text'
    | 'primary-opacity'
    | 'accent'
    | 'accent-stroked'
    | 'accent-text'
    | 'accent-opacity'
    | 'warn'
    | 'warn-stroked'
    | 'warn-text'
    | 'warn-opacity';
  @Input() type = '';
  @Input() placeholder = '';
  @Input() debounce = 500;
  @Input() data = [];

  @Output() inputEmit: EventEmitter<string> = new EventEmitter<string>();

  constructor(private fb: FormBuilder, private el: ElementRef) {}

  selectedItem: any;
  value: any;
  isOpen: boolean = false;

  disabled: boolean;
  destroy$ = new Subject();

  ngOnInit(): void {
    this.setupListeners();
  }
  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  onChange(_: any) {}
  onTouched = () => {};

  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  writeValue(value: any) {
    this.value = value;
  }
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  setupListeners() {
    fromEvent(document, 'click')
      .pipe(takeUntil(this.destroy$))
      .subscribe((e) => {
        if (!this.el.nativeElement.contains(e.target)) {
          this.isOpen = false;
        } else {
          this.isOpen = true;
        }
      });
  }

  onSelect(e, item) {
    e.stopPropagation();
    this.value = item.name;
    this.selectedItem = item;
    this.isOpen = false;
  }
}
